import script from "./dialogFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogFooter.vue?vue&type=script&setup=true&lang=js"

import "./dialogFooter.vue?vue&type=style&index=0&id=d2972bae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1751107138/src/flip-child-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2972bae"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QCheckbox,QCardActions,QBtn,QCard});
